"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.hasAwaited = exports.deepEqual = exports.decoder = void 0;
const types_collection_1 = require("@framework/types-collection");
// https://github.com/ljharb/qs/issues/91#issuecomment-522289267
const decoder = (str, _decoder, charset) => {
    const strWithoutPlus = str.replace(/\+/g, " ");
    if (charset === "iso-8859-1") {
        // unescape never throws, no try...catch needed:
        return strWithoutPlus.replace(/%[0-9a-f]{2}/gi, unescape);
    }
    if (/^(\d+|\d*\.\d+)$/.test(str)) {
        const parsed = parseFloat(str);
        return parsed.toString() === str ? parsed : str;
    }
    const keywords = {
        true: true,
        false: false,
        null: null,
        undefined: void 0,
    };
    if (str in keywords) {
        return keywords[str];
    }
    try {
        return decodeURIComponent(strWithoutPlus);
    }
    catch (e) {
        return strWithoutPlus;
    }
};
exports.decoder = decoder;
/**
 * Compares two objects for deep equality.
 *
 * @template T - The type of the objects being compared.
 * @param {T} obj1 - The first object to compare.
 * @param {T} obj2 - The second object to compare.
 * @param {WeakMap<object, object>} [stack=new WeakMap()] - A WeakMap to handle circular references.
 * @returns {boolean} - Returns `true` if the objects are deeply equal, otherwise `false`.
 */
const deepEqual = (obj1, obj2, stack = new WeakMap()) => {
    // Быстрая проверка на полное равенство объектов
    if (obj1 === obj2)
        return true;
    // Проверка на null/undefined
    if (obj1 == null || obj2 == null)
        return false;
    // Проверка что оба аргумента являются объектами
    if (typeof obj1 !== "object" || typeof obj2 !== "object")
        return false;
    // Защита от циклических ссылок через WeakMap
    if (stack.get(obj1) === obj2)
        return true;
    stack.set(obj1, obj2);
    // Специальная обработка для массивов
    if (Array.isArray(obj1) && Array.isArray(obj2)) {
        if (obj1.length !== obj2.length)
            return false;
        return obj1.every((item, index) => (0, exports.deepEqual)(item, obj2[index], stack));
    }
    // Сравнение количества ключей
    const keys1 = Object.keys(obj1);
    if (keys1.length !== Object.keys(obj2).length)
        return false;
    // Рекурсивное сравнение всех значений по ключам
    const result = keys1.every(key => Object.prototype.hasOwnProperty.call(obj2, key) && (0, exports.deepEqual)(obj1[key], obj2[key], stack));
    return result;
};
exports.deepEqual = deepEqual;
const hasAwaited = (obj) => Object.values(obj).some(val => val === types_collection_1.InputType.awaited || (typeof val === "object" && (0, exports.hasAwaited)(val)));
exports.hasAwaited = hasAwaited;
//# sourceMappingURL=utils.js.map